import { updateState } from '../../shared/mutations';
import { VideoTemplateStateContent } from '../../types';

export function setTemplateUCSCompatibility(
  state: VideoTemplateStateContent,
  isCompatible: boolean,
) {
  return updateState(state, {
    template: {
      ...state.template,
      isUCSEditorCompatible: isCompatible,
    },
  });
}

export function setTemplateUCSCompatibilityLoading(
  state: VideoTemplateStateContent,
  isLoading: boolean,
) {
  return updateState(state, {
    template: {
      ...state.template,
      isUCSEditorCompatibleLoading: isLoading,
    },
  });
}
